import React from "react";
import ApiService from "../../../Services/ApiService.js";


class positionSeniorityCheckbox extends React.Component {

    state = {
        seniorities: [],
        selected_seniorities: []

    };

    isChecked(job) {
        return this.state.selected_seniorities.includes(job);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let allSeniorities = this.state.seniorities;

        if (allSeniorities.length === 0) {
            setTimeout(this.setSelectedSeniorities(nextProps), 2000);
        } else {
            this.setSelectedSeniorities(nextProps);
        }
    }
    
    componentDidMount() {
        this.fetchSeniorities();
    }
    
    fetchSeniorities() {
        ApiService.get('/api/campaigns/fetch-seniorities').then(response => {
            this.setState({
                seniorities: response.data.seniorities,
            }, function() {
                this.setSelectedSeniorities(this.props)

            });
        });
    }

    setSelectedSeniorities(nextProps) {
        let allSeniorities = this.state.seniorities;

        let selectedSeniorities = nextProps.data.filter(function (el) {
            return allSeniorities.indexOf(el) > -1;
        });

        this.setState({...this.state, selected_seniorities: selectedSeniorities});
    }

    handleChange(event) {
        var seniority = event.target.value;
        var selectedPositions = this.state.selected_seniorities;
        if (event.target.checked) {
            selectedPositions.push(seniority);
            this.setState({...this.state,
                selected_seniorities: selectedPositions
            });


        } else {
            var index = this.state.selected_seniorities.indexOf(seniority);
            if (index > -1) {
                selectedPositions.splice(index, 1);

                this.setState({...this.state,
                    selected_seniorities: selectedPositions
                });
            }
        }

        this.props.onSenioritiesChange(selectedPositions);

    }

    render() {
        var allPositions = JSON.parse(JSON.stringify(this.state.seniorities));
        var positionsArray = [], size = 5;

        while (allPositions.length > 0) {
            positionsArray.push(allPositions.splice(0, size));
        }

        if (positionsArray.length > 0) {
            return(
                <div className="position-seniority">

                <div className="position-seniority-column">
                {positionsArray[0].map( (seniority, index) =>
                        <label className="checkmark-container" key={index}>{seniority}
                    <input type="checkbox" checked={this.isChecked(seniority)} key={index} value={seniority} onChange={this.handleChange.bind(this)}/>
            <span className="checkmark"> </span>
                </label>

        )}
                </div>

            <div className="position-seniority-column">
                {positionsArray[1].map( (seniority, index) =>
                        <label className="checkmark-container" key={index}>{seniority}
                    <input type="checkbox" checked={this.isChecked(seniority)} key={index} value={seniority} onChange={this.handleChange.bind(this)}/>
            <span className="checkmark"> </span>
                </label>

        )}
        </div>


        </div>
        )
        } else {
            return null;
        }

    }
}

export default positionSeniorityCheckbox